import '.a{display:flex;}.ssr-plugin'
import '.ac{flex-direction:column;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.bk{gap:8px;}.ssr-plugin'
import '.hl{height:120px;}.ssr-plugin'
import '.hm{vertical-align:center;}.ssr-plugin'
import '.hn{font-size:0px;}.ssr-plugin'
import '.fk{padding:8px;}.ssr-plugin'
import '.fu{overflow-y:auto;}.ssr-plugin'
import '.fv{overflow-x:hidden;}.ssr-plugin'
import '.ho{max-width:100%;}.ssr-plugin'
import '.em{display:inline-flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.fl{padding:4px;}.ssr-plugin'
import '.hp{cursor:not-allowed;}.ssr-plugin'
import '.co{margin-bottom:8px;}.ssr-plugin'
import '.a6{margin-right:8px;}.ssr-plugin'
import '.eq{outline:none;}.ssr-plugin'
import '.hi{width:2px;}.ssr-plugin'
import '.am{height:100%;}.ssr-plugin'
import '.ek{flex-shrink:0;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.a1{gap:4px;}.ssr-plugin'
import { useState } from 'react'
import { Button } from '../Button/index.js'
import { Modal } from '../Modal/index.js'
import { TextInput } from '../TextInput/index.js'
import { SelectInput, SelectInputProps } from '../SelectInput/index.js'
import { NumberInput } from '../NumberInput/index.js'
import { DateInput } from '../DateInput/index.js'
import { Icon, IconProps } from '../Icon/index.js'
import { Text } from '../Text/index.js'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { styled } from 'inlines'
import { LabelDescription } from '../LabelDescription/index.js'

type StringTagInputProps = {
  variant: 'string'
  value?: string[]
  onChange: (value: string[]) => void
}
type NumberTagInputProps = {
  variant: 'number'
  value?: number[]
  onChange: (value: number[]) => void
}
type BooleanTagInputProps = {
  variant: 'boolean'
  value?: boolean[]
  onChange: (value: boolean[]) => void
}
type EnumTagInputProps = {
  variant: 'enum'
  value?: string[]
  onChange: (value: string[]) => void
  options: SelectInputProps['options']
}
type DateTimeTagInputProps = {
  variant: 'date-time'
  value?: number[]
  onChange: (value: number[]) => void
}

type TagInputProps = (
  | StringTagInputProps
  | NumberTagInputProps
  | BooleanTagInputProps
  | EnumTagInputProps
  | DateTimeTagInputProps
) & {
  disabled?: boolean
  label?: string
  description?: string
  error?: boolean
  errorMessage?: string
  placeholder?: string
  placeholderIcon?: IconProps['variant']
}

const TagInput = (props: TagInputProps) => {
  const value = props.value ?? []
  const [editIndex, setEditIndex] = useState<number>()
  const [editValue, setEditValue] = useState<string | number | boolean>()

  return (
    <LabelDescription
      label={props.label}
      description={props.description}
      error={props.error && props.errorMessage}
    >
      <div className="a ac f bk"
      >
        <styled.div className="f hl hm hn fk fu fv"
          style={{
            borderRadius: radius[12],
            border: `1px solid ${colors.neutral20Adjusted}`,
            ...(props.error && {
              border: `1px solid ${colors.red80}`,
            }),
            ...(props.disabled && {
              cursor: 'not-allowed',
              color: colors.neutral20,
              background: colors.neutral5,
              border: `1px solid transparent`,
            }),
          }}
        >
          {Boolean(value?.length) &&
            value.map((val, index) => (
              <styled.div className="ho em d fl hp co a6 eq"
                onClick={() => {
                  if (props.disabled) return
                  setEditIndex(index)
                  setEditValue(val)
                }}
                style={{
                  borderRadius: radius[6],
                  background: colors.neutral10Adjusted,
                  color: colors.neutral20,
                  ...(!props.disabled && {
                    color: colors.neutral80,
                    cursor: 'pointer',
                    '&:hover': {
                      background: colors.neutral20Adjusted,
                    },
                  }),
                }}
              >
                <div className="hi am ek"
                />
                <Text singleLine variant="subtext-medium" color="inherit">
                  {props.variant === 'date-time'
                    ? new Date(val as number).toLocaleString()
                    : val.toString()}
                </Text>
                <div className="hi am ek"
                />
                <styled.div className="ek a d c hp"
                  onClick={(e) => {
                    if (props.disabled) return
                    e.stopPropagation()
                    props.onChange(value.filter((_, i) => i !== index) as any)
                  }}
                  style={{
                    borderRadius: radius[6],
                    ...(!props.disabled && {
                      cursor: 'pointer',
                      '&:hover': {
                        background: colors.neutral20Adjusted,
                      },
                    }),
                  }}
                >
                  <Icon variant="close" size="small" />
                </styled.div>
              </styled.div>
            ))}
          {Boolean(!value?.length) && (
            <div className="f am c d a ac a1"
              style={{
                color: colors.neutral60,
              }}
            >
              {props.placeholderIcon && (
                <Icon variant={props.placeholderIcon} />
              )}
              {props.placeholder && (
                <Text variant="subtext-medium" color="inherit">
                  {props.placeholder}
                </Text>
              )}
            </div>
          )}
        </styled.div>

        <div className="a bk">
          <Modal size="small">
            <Modal.Trigger>
              <Button
                leadIcon="add"
                variant="border"
                onClick={() => {
                  setEditIndex(undefined)
                  setEditValue(undefined)
                }}
                disabled={props.disabled}
              >
                Add {props.variant}
              </Button>
            </Modal.Trigger>
            <Modal.Content>
              <Modal.Header
                title={
                  typeof editIndex === 'number'
                    ? `Edit ${props.variant}`
                    : `Add ${props.variant}`
                }
              />
              <Modal.Body>
                {props.variant === 'string' && (
                  <TextInput
                    value={editValue as string}
                    onChange={setEditValue}
                    autoFocus
                  />
                )}
                {props.variant === 'number' && (
                  <NumberInput
                    value={editValue as number}
                    onChange={setEditValue}
                    autoFocus
                  />
                )}
                {props.variant === 'boolean' && (
                  <SelectInput
                    value={editValue as boolean}
                    onChange={setEditValue}
                    options={[
                      { value: true, label: 'True' },
                      { value: false, label: 'False' },
                    ]}
                  />
                )}
                {props.variant === 'enum' && (
                  <SelectInput
                    value={editValue as string}
                    onChange={setEditValue}
                    options={props.options}
                  />
                )}
                {props.variant === 'date-time' && (
                  <DateInput
                    value={editValue as number}
                    onChange={setEditValue}
                    variant="date-time"
                  />
                )}
              </Modal.Body>
              <Modal.Footer>
                <div style={{ display: 'flex', gap: 8 }}>
                  <Button
                    variant="border"
                    onClick={() => Modal.Close()}
                    keyHint="Esc"
                  >
                    Cancel
                  </Button>
                  <Button
                    keyHint="Enter"
                    disabled={typeof editValue === 'undefined'}
                    onClick={() => {
                      if (typeof editIndex !== 'undefined') {
                        props.onChange(
                          value.map(
                            (e, i) => (i === editIndex ? editValue : e) as any,
                          ),
                        )
                      } else {
                        props.onChange([...value, editValue as any])
                      }
                      Modal.Close()
                      setEditValue(undefined)
                      setEditIndex(undefined)
                    }}
                  >
                    {editIndex ? 'Save' : 'Add'}
                  </Button>
                </div>
              </Modal.Footer>
            </Modal.Content>
          </Modal>
        </div>
      </div>
    </LabelDescription>
  )
}

export { TagInput }
export type { TagInputProps, EnumTagInputProps }
